//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SfMenuItem from "../../../molecules/SfMenuItem/SfMenuItem.vue";
export default {
  name: "SfMegaMenuColumn",
  components: {
    SfMenuItem,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    link: {
      type: [String, Object],
      default: null,
    },
    icon: {
      type: String,
      default: 'chevron_right'
    }
  },
  inject: ["megaMenu"],
  computed: {
    active() {
      return this.megaMenu?.active;
    },
  },
};
